<template>
  <div class="children_container">
    <back-header title="新增孩子"/>
    <child-detail :is-edit="false"/>
  </div>
</template>

<script>
import backHeader from '@/components/backHeader.vue'
import childDetail from './components/childDetail'

export default {
  name: 'child-add',
  components: {
    backHeader,
    childDetail
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
